import type { SVGMotionProps, Transition } from 'motion/react'
import { motion } from 'motion/react'

const transition: Transition = {
  duration: 0.7,
  type: 'spring',
  bounce: 0.4,
}

export const Sparkles = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      whileHover="hover"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      <motion.path
        variants={{
          hover: { scale: 0.6, x: '15%', transition: { delay: 0.1 } },
        }}
        transition={transition}
        fill="currentColor"
        fillRule="evenodd"
        d="M12.34 5.42c.202-.797 1.264-.83 1.572-.15l.05.147.002.003.59 2.331.039.132a2.01 2.01 0 0 0 1.413 1.32l2.332.592c.853.215.834 1.41.002 1.623l-.002.001-2.33.59a2.011 2.011 0 0 0-1.454 1.454l-.59 2.33-.001.003c-.213.83-1.409.85-1.623-.003l-.592-2.33a2.011 2.011 0 0 0-1.32-1.415l-.132-.038-2.331-.59-.003-.002c-.828-.214-.848-1.408.003-1.623l2.33-.592a2.008 2.008 0 0 0 1.453-1.452l.592-2.33Zm-4.043 5.686-.002.001.005-.002-.003.001Zm9.711.001h-.002l-.004-.002.006.002Z"
        clipRule="evenodd"
      />
      <motion.path
        variants={{
          hover: {
            scale: 1.8,
            x: '20%',
            y: '-25%',
            transition: { delay: 0.1 },
          },
        }}
        transition={transition}
        fill="currentColor"
        fillRule="evenodd"
        d="M4.787 12.469c.091-.364.576-.38.717-.068l.023.066v.002l.27 1.064.018.06c.097.297.34.525.645.603l1.064.27c.39.098.38.644.001.74v.001l-1.065.27a.918.918 0 0 0-.663.663l-.27 1.064c-.097.38-.643.389-.74 0l-.27-1.064a.918.918 0 0 0-.603-.646l-.06-.017-1.065-.27h-.001c-.378-.098-.387-.643.001-.74l1.064-.271a.917.917 0 0 0 .663-.663l.27-1.064ZM2.94 15.064h.001Zm4.433 0H7.37h.003Z"
        clipRule="evenodd"
      />
      <motion.path
        variants={{
          hover: {
            scale: 0.7,
            x: '65%',
            y: '-15%',
            transition: { delay: 0.1 },
          },
        }}
        transition={transition}
        fill="currentColor"
        fillRule="evenodd"
        d="M4.332 3.285c.12-.48.76-.5.945-.09l.03.088.001.002.355 1.402.024.08c.128.39.448.69.85.793l1.403.357c.513.128.5.847 0 .976l-1.402.355a1.21 1.21 0 0 0-.875.874l-.355 1.403c-.128.5-.848.512-.976-.001l-.357-1.402a1.21 1.21 0 0 0-.794-.85l-.08-.024L1.7 6.893h-.002c-.498-.13-.51-.847.002-.976l1.402-.357c.43-.109.764-.444.873-.873l.357-1.402ZM1.9 6.705h-.002.004H1.9Zm5.841 0h-.004.004Z"
        clipRule="evenodd"
      />
    </motion.svg>
  )
}
